import React from 'react';
import * as formatters from '../../utils/formatters';
import { useTranslation } from 'react-i18next';

function DrawDate({ date, timezone }) {
    const { formatLongWithTimezone, formatDateStringShort } = formatters;
    const { t } = useTranslation();

    function getDisplayValue() {
        if (date) {
            return (
                <time dateTime={formatDateStringShort(date)}>
                    {formatLongWithTimezone(date, timezone)}
                </time>
            );
        }
        return <span>{t('latestResults.pending')}</span>;
    }

    return getDisplayValue();
}

export default DrawDate;
